module.exports = __webpack_public_path__ + "img/okay.723c5a7f.svg";